import React from 'react';
import { Link } from 'react-router-dom';

import { Container } from '../components/_atoms';
import { ROUTES } from '../constants';
import { GridColDef, DataGrid, GridToolbar, GridRenderCellParams, GridValueGetter } from '@mui/x-data-grid';
import { SchoolDTO } from '../DTO/SchoolDTO';
import { Button, FormGroup, Typography } from '@mui/material';
import { getDateAndTime } from '../util/dateHelper';
import { useSchools } from '../contexts';

const colDefs: GridColDef[] = [
	{ field: 'id', headerName: 'ID', type: 'number', flex: 0.5, minWidth: 50 },
	{ field: 'name', headerName: 'Name', flex: 1, minWidth: 200 },
	{
		field: 'created',
		headerName: 'Created',
		type: 'dateTime',

		flex: 1,
		minWidth: 200,
		valueGetter: ((value, row: SchoolDTO) =>
			row?.created ? new Date(row.created) : null) as GridValueGetter<SchoolDTO, Date | null>,
	},
	{
		field: 'modified',
		headerName: 'Modified',
		flex: 1,
		type: 'dateTime',
		minWidth: 200,
		valueGetter: ((value, row: SchoolDTO) =>
			row?.modified ? new Date(row.modified) : null) as GridValueGetter<SchoolDTO, Date | null>,
	},
	{
		field: 'country',
		headerName: 'Country',
		flex: 1,
		minWidth: 200,
		valueGetter: ((value, row: SchoolDTO) => row?.country?.name) as GridValueGetter<SchoolDTO, string>,
	},
	{
		field: 'edit',
		headerName: 'Open',
		flex: 1,
		minWidth: 100,
		renderCell: (params: GridRenderCellParams<SchoolDTO>) => (
			<Button
				variant="contained"
				color="primary"
				size="small"
				component={Link}
				to={`${ROUTES.SCHOOL}/${params.row.id}`}
			>
				Open
			</Button>
		),
	},
	{
		field: 'courses',
		headerName: 'Courses',
		flex: 1,
		minWidth: 100,
		renderCell: (params: GridRenderCellParams<SchoolDTO>) => (
			<Button
				variant="contained"
				color="primary"
				size="small"
				component={Link}
				to={`${ROUTES.COURSES}/${params.row.id}`}
			>
				Courses
			</Button>
		),
	},
];

const Schools = () => {
	const schools = useSchools();

	if (!schools) return null;
	return (
		<Container>
			<Typography
				gutterBottom
				style={{ marginTop: '5px' }}
				variant="h4"
				align="center"
			>
				Universities
			</Typography>
			<FormGroup row>
				<Button
					variant="contained"
					color="secondary"
					style={{ float: 'right' }}
					size="small"
					component={Link}
					to={`${ROUTES.SCHOOL}/${0}`}
				>
					Create new
				</Button>
			</FormGroup>
			<div
				style={{
					height: 'calc(100vh - 200px)',
					width: '100%',
					marginTop: '10px',
				}}
			>
				<DataGrid
					columns={colDefs}
					rows={schools}
					slots={{
						toolbar: GridToolbar,
					}}
				/>
			</div>
		</Container>
	);
};

export default Schools;
